import { VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { setLoginModalType } from "@redux/slices/appStateSlice";
import React from "react";
import { TouchableOpacity } from "react-native";
import { useDispatch } from "react-redux";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { useTranslation } from "react-i18next";

const GuestLogin = () => {
  const dispatch = useDispatch();
  const { theme, typography } = useScreenOptionsHooks();
  const { t } = useTranslation();
  return (
    <TouchableOpacity onPress={() => dispatch(setLoginModalType("default"))}>
      <GetPriceContainer>
        <VDBText color={theme["link-static"]} type={typography["Body-M"]}>
          {t("productDetail.login.text")}
        </VDBText>
      </GetPriceContainer>
    </TouchableOpacity>
  );
};

const GetPriceContainer = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-color: ${({ theme }) => theme["core-03"]};
  border-width: 1px;
  border-radius: ${SpaceType.Basic}px;
  padding: ${SpaceType.Double}px;
  align-items: center;
`;

export default GuestLogin;
